import { EventEmitter, Injectable, Output,OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, tap, delay, finalize } from 'rxjs/operators';
import { Config } from "../../config/constants";
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { ApplicationUser } from '../models/application-user';
import { UserService } from 'src/app/core/services/user.service';
import  jwt_decode from 'jwt-decode';
import { AppService } from "src/app/app.service";

interface LoginResult {
  username: string;
  roles: [];
  userProfile:any;
  tokenType: string;
  accessToken: string;
  refreshToken: string;
  expiryDuration;
  firstTime;
}
//const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  jwtToken: string;
 private _userSubject: BehaviorSubject<ApplicationUser>;
    public user: Observable<ApplicationUser>;
   
  constructor(private http: HttpClient,private config:Config,public userService: UserService,private appService: AppService,private router: Router) { 
    //this._userSubject = new BehaviorSubject<ApplicationUser>(null);
    //debugger
    this._userSubject = new BehaviorSubject<ApplicationUser>(JSON.parse(sessionStorage.getItem('currentUserBroker')))
    this.user = this._userSubject.asObservable();
    
   }
  ngOnDestroy(): void {
   
  }
  public get userValue(): ApplicationUser {
    return this._userSubject.value;
}
public userNameChange(user:ApplicationUser){
  this._userSubject.next(null);
  sessionStorage.removeItem('currentUserBroker')
  
  this._userSubject.next(user);
  sessionStorage.setItem('currentUserBroker', JSON.stringify(user));
}
public set userValueName(user: ApplicationUser) {
this._userSubject.next(user);
}
  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();

    login(email: string, password:string,fcmToken: any,deviceId: any){
     // this.stopRefreshTokenTimer();
      this._userSubject.next(null);
      //sessionStorage.clear();
      return this.http.post<any>(`${this.config.authapiurl}`, {email,password,fcmToken,deviceId})
      .pipe(
          map(user => {
              // login successful if the response has jwt token
              if(user && user.accessToken){
               sessionStorage.setItem('currentUserBroker', JSON.stringify(user));
               localStorage.setItem('refreshtoken',user.refreshToken)
                this._userSubject.next(user);
                sessionStorage.setItem('loginAttempted', 'true');
                sessionStorage.removeItem('loginURLAttempted');
               
               // this.startRefreshTokenTimer();
                  var flag =false;
                  for(var i=0;i<user.roles.length;i++)
                  {
                    if(user.roles[i].role=="ROLE_LEAD_BROKER")
                    {
                      flag=true;
                      
                    }
                    sessionStorage.setItem('leadMgaId',user.roles[i].id)
                  }
                  let daa=''+flag;
                  sessionStorage.setItem('flag', daa);
                  let name=user.userProfile.firstName+" "+user.userProfile.lastName;
                  sessionStorage.setItem('username', name);
                  this.getLoggedInName.emit(user);

              }

              return user;
          })
      );
  }
  refreshTokenGet: any;
  logout() {
    debugger
    // this.http.post<any>(`${this.config.logoutapiurl}`, { withCredentials: true }).subscribe();
   // this.stopRefreshTokenTimer();
   this.refreshTokenGet = localStorage.getItem('refreshtoken')
   this.userService.logoutCall(this.refreshTokenGet).pipe()
   .subscribe(
       data => {
        this.appService.setUserLoggedIn(false);
        this._userSubject.next(null);
        this.appService.setUserLoggedIn(false);
        this.router.navigate(['/login']);
        sessionStorage.removeItem('leadMgaId');
        sessionStorage.removeItem('fcmToken');
        sessionStorage.removeItem('leadId');
        sessionStorage.removeItem('leadEmailInfo');
        sessionStorage.removeItem('flag');
        sessionStorage.removeItem('leadStatus');
        sessionStorage.removeItem('stagesViews');
        sessionStorage.removeItem('username');
        sessionStorage.removeItem('currentUserBroker');
        sessionStorage.removeItem('leadtype');
        localStorage.removeItem('email');
        localStorage.removeItem('pass');
        localStorage.removeItem('fcmToken');
        sessionStorage.setItem('checkUserIsCancelledannualConfirmationPopup', 'false');
        this.router.navigate(['/login']);
        // localStorage.clear();
        // sessionStorage.clear()
       },error=>{
        
           },()=>{});
  
   // this.router.navigate(['/login']);
}
  refreshToken_OLD() {
    // const refreshToken = sessionStorage.getItem('refresh_token');
    // if (!refreshToken) {
    //   this.clearsessionStorage();
    //   return of(null);
    // }
    
    var refreshToken=this.userValue.refreshToken
    this.http.post<any>(`${this.config.refreshToken}`, {refreshToken})
    .pipe(
        map(user => {
               if(user){
            this._userSubject.next(null);
            
            sessionStorage.clear();
           this._userSubject.next(user);
          
              sessionStorage.setItem('currentUserBroker', JSON.stringify(user));
          }
            return user;
        })
    );
  }
  refreshToken(){
   // this.userValue.accessToken="";
     
    var refreshToken=this.userValue.refreshToken
    
  return this.http.post<LoginResult>(`${this.config.refreshToken}`, {refreshToken}).pipe(
    map(
        user => {
        if(user){
          this._userSubject.next(null);
         //sessionStorage.clear();
         sessionStorage.removeItem('currentUserBroker')
         this._userSubject.next(user);
       
        this.userValue.accessToken=user.accessToken
        sessionStorage.setItem('currentUserBroker', JSON.stringify(user));
        }
        return user;
      }
      //)
      )
      );
      
  }
  // helper methods

  private refreshTokenTimeout;

  private startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(this.userValue.accessToken.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
   // this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
}
private stopRefreshTokenTimer() {
  clearTimeout(this.refreshTokenTimeout);
}
  setPassword(confirmPassword:string,password:string,token: any){
    return this.http.post<any>(`${this.config.setPassword}`, {confirmPassword,password,token})
    .pipe(
        // the backend service sends an instance of the user
        // user: any (because .post<any>)
        map(user => {
            // login successful if the response has jwt token
            if(user && user.accessToken){

              // // store user details and jwt token in the local storage to keep the user logged in between page refreshes
              // sessionStorage.setItem('currentUser', JSON.stringify(user));
              // // console.log('came',user)
              // sessionStorage.setItem('userToken', JSON.stringify(user.accessToken));
              sessionStorage.setItem('currentUserBroker', JSON.stringify(user));
              this._userSubject.next(user);
             // this.startRefreshTokenTimer();
              var flag =false;
              for(var i=0;i<user.roles.length;i++)
              {
                if(user.roles[i].role=="ROLE_LEAD_BROKER")
                {
                  flag=true;
            
                }
              }
              let daa=''+flag;
              sessionStorage.setItem('flag', daa);
              let name=user.userProfile.firstName+" "+user.userProfile.lastName;
              sessionStorage.setItem('username', name);
          
      this.getLoggedInName.emit(user);

          }

            return user;
        })
    );
}

setNewPassword(confirmPassword:string,password:string,token:string){
return this.http.post<any>(`${this.config.setnewPassword}`, {confirmPassword,password,token})
  .pipe(
      map(user => {
         return user;
      })
  );
}


isTokenExpired() {
// check if token is expired
if(this.userValue){
  const jwtToken = JSON.parse(atob(this.userValue.accessToken.split('.')[1]));
  const tokenExpired = Date.now() > (jwtToken.exp * 1000);
  if (tokenExpired)
  { return true;
  }else{
    return false;
  }
}else{ return false;}
}
 
}
